import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";

export type DateFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useDateFieldController = (props: DateFieldProps) => {
  const { datasheetElement, onChange } = props;

  // const valueFromProps = datasheetElement.original.field.value;
  const valueFromProps = '';

  const [fieldValue, setFieldValue] = React.useState(valueFromProps ?? '');

  React.useEffect(() => {
    if (fieldValue !== valueFromProps) {
      setFieldValue(valueFromProps ?? '');
    }
  }, [valueFromProps]);

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const handleDateFieldValueChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.value);
  }, []);

  const handleDateFieldValueSave = React.useCallback(() => {
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          name: fieldValue,
        },
      },
    });
  }, [onChange, fieldValue, datasheetElement]);

  return {
    handleDateFieldValueSave,
    handleDateFieldValueChange,
    headingPosition,
    headingPlacedHorizontally,
    fieldValue,
    ...baseDatasheetElementController,
  };
};